import {ApolloLink} from 'apollo-link';

const logLink = new ApolloLink( ( operation, forward ) => {
    // Payment inputs and token responses must never be included in console logs.
    console.warn( `[request] ${operation.operationName}` );
    return forward( operation ).map( ( response ) => {
        console.warn( `[response] ${operation.operationName}` );
        return response;
    } )
} );

export default logLink;
